import { NgModule } from '@angular/core';

import { ProtectedControlDirective } from './protected-control.directive';
import { ProtectedControlsContextDirective } from './protected-controls-context.directive';
import {
  protectedControlsServiceFactoryWithoutParent,
  providersForControlsContext,
} from './protected-controls.providers';
import { ProtectedControlsService } from './protected-controls.service';

@NgModule({
  declarations: [ProtectedControlDirective, ProtectedControlsContextDirective],
  exports: [ProtectedControlDirective, ProtectedControlsContextDirective],
})
export class ProtectedControlsModule {}

export {
  ProtectedControlsService,
  providersForControlsContext,
  protectedControlsServiceFactoryWithoutParent,
};
